/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The filter of storage unit notification registration
 */
export interface StorageUnitNotificationFilter { 
    /**
     * The namespace of the business object definition
     */
    namespace: string;
    /**
     * The business object definition name
     */
    businessObjectDefinitionName: string;
    /**
     * The business object format usage
     */
    businessObjectFormatUsage?: string;
    /**
     * The business object format file type
     */
    businessObjectFormatFileType?: string;
    /**
     * The business object format version
     */
    businessObjectFormatVersion?: number;
    /**
     * The storage name
     */
    storageName: string;
    /**
     * The new storage unit status. One of the following values: ENABLED, DISABLED, ARCHIVING, or RESTORING
     */
    newStorageUnitStatus?: string;
    /**
     * The old storage unit status. One of the following values: ENABLED, DISABLED, ARCHIVING, or RESTORING
     */
    oldStorageUnitStatus?: string;
}
